var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact"},[_c('Banner',{attrs:{"banner":_vm.response.banner}}),_c('Intro',{attrs:{"title":_vm.response.intro.title,"text":_vm.response.intro.text,"mod":"lime"}}),_c('Office',{attrs:{"offices":_vm.response.offices,"apiKey":_vm.response.apiKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }